import { useState } from "react";
import { Link } from "react-router-dom";

export const SidebarItem = ({ item, depth = 0, t, doesRouteInclude }) => {
  const [open, setOpen] = useState(false);

  const hasChildren = item.children && item.children.length > 0;

  const toggleMenu = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  if (!hasChildren) {
    return (
      <Link
        to={item.link}
        className={
          doesRouteInclude(item.link) ?
            "nav-item nav-link active"
          : "nav-item nav-link"
        }
        style={{ paddingLeft: `${15 + depth * 15}px` }}>
        {item.icon && <i className={item.icon}></i>}
        {t(item.label)}
      </Link>
    );
  }

  return (
    <div className="sidebar-group">
      <div
        className="nav-item nav-link d-flex justify-content-between align-items-center"
        onClick={toggleMenu}
        style={{ paddingLeft: `${15 + depth * 15}px`, cursor: "pointer" }}>
        <span>
          {item.icon && <i className={item.icon}></i>}
          {t(item.label)}
        </span>

        <i className={`fa fa-chevron-${open ? "down" : "right"}`} />
      </div>

      {open && (
        <div className="submenu">
          {item.children.map((child, index) => (
            <SidebarItem
              key={index}
              item={child}
              depth={depth + 1}
              t={t}
              doesRouteInclude={doesRouteInclude}
            />
          ))}
        </div>
      )}
    </div>
  );
};
